import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PrintedTee = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.PrintedTee.itemName}
      name={AW23.tops.PrintedTee.itemName}
      price={AW23.tops.PrintedTee.itemPrice}
      fabric={AW23.tops.PrintedTee.itemFabric}
      src={AW23.tops.PrintedTee.sizeChart}
      divId={AW23.tops.PrintedTee.shopifyDivId}
      mainId={AW23.tops.PrintedTee.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.PrintedTee.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.PrintedTee.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PrintedTee;
